import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, resolveDirective as _resolveDirective, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/img/chevronLeft.svg'


const _hoisted_1 = { class: "genericPadding hasHeader hasFooter bgWhite" }
const _hoisted_2 = { class: "header withShadow d-flex aling-items-center justify-content-between py-4" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "sideContainer" }, null, -1)
const _hoisted_5 = { class: "horizontalForm mt-4" }
const _hoisted_6 = { class: "form-group squareInputContainer withLabel" }
const _hoisted_7 = { class: "form-group squareInputContainer withLabel" }
const _hoisted_8 = { class: "form-group squareInputContainer withLabel" }
const _hoisted_9 = { class: "form-group squareInputContainer withLabel" }
const _hoisted_10 = { class: "form-group squareInputContainer withLabel" }
const _hoisted_11 = { class: "form-group squareInputContainer withLabel mt-3" }
const _hoisted_12 = { class: "d-flex flex-wrap" }
const _hoisted_13 = {
  key: 0,
  class: "error"
}
const _hoisted_14 = { class: "footerButtonContainer" }

export function render(_ctx: any,_cache: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_mini_spinner = _resolveComponent("mini-spinner")!
  const _component_user_profile_image = _resolveComponent("user-profile-image")!
  const _component_file_selector = _resolveComponent("file-selector")!
  const _component_uose_writer = _resolveComponent("uose-writer")!
  const _directive_date = _resolveDirective("date")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: "sideContainer",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
      }, [
        _hoisted_3
      ]),
      _createVNode(_component_localized_text, {
        class: "fs_12 greyBlue",
        localizedKey: "app_aggiornainformazioni",
        text: "Aggiorna informazioni"
      }),
      _hoisted_4
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_mini_spinner, { key: 0 }))
      : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
          _createVNode(_component_file_selector, {
            modelValue: _ctx.vm.file,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.vm.file = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_user_profile_image, {
                class: "profileImageRound",
                src: _ctx.$store.state.getUserImage(_ctx.profile.identifier)
              }, null, 8, ["src"]),
              _createVNode(_component_localized_text, {
                localizedKey: "app_cambiafotoprofilo",
                text: "Cambia foto profilo",
                class: "fs_14 grey d-block text-center mt-2"
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode("label", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "app_nome",
                  text: "Nome",
                  class: "fs_12 grey"
                })
              ]),
              _withDirectives(_createVNode("input", {
                type: "text",
                class: "genericInput squareInput",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.profile.name = $event))
              }, null, 512), [
                [_vModelText, _ctx.profile.name]
              ])
            ]),
            _createVNode("div", _hoisted_7, [
              _createVNode("label", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "app_cognome",
                  text: "Cognome",
                  class: "fs_12 grey"
                })
              ]),
              _withDirectives(_createVNode("input", {
                type: "text",
                class: "genericInput squareInput",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.profile.surname = $event))
              }, null, 512), [
                [_vModelText, _ctx.profile.surname]
              ])
            ]),
            _createVNode("div", _hoisted_8, [
              _createVNode("label", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "app_email",
                  text: "Email",
                  class: "fs_12 grey"
                })
              ]),
              _withDirectives(_createVNode("input", {
                type: "text",
                class: "genericInput squareInput",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.profile.email = $event))
              }, null, 512), [
                [_vModelText, _ctx.profile.email]
              ])
            ]),
            _createVNode("div", _hoisted_9, [
              _createVNode("label", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "app_numero",
                  text: "Numero",
                  class: "fs_12 grey"
                })
              ]),
              _withDirectives(_createVNode("input", {
                type: "text",
                class: "genericInput squareInput",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.profile.telephone = $event))
              }, null, 512), [
                [_vModelText, _ctx.profile.telephone]
              ])
            ]),
            _createVNode("div", _hoisted_10, [
              _createVNode("label", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "app_datadinascita",
                  text: "Data di nascita",
                  class: "fs_12 grey"
                })
              ]),
              _withDirectives(_createVNode("input", {
                type: "date",
                class: "genericInput squareInput dateInput infoDate",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.profile.birthDate = $event))
              }, null, 512), [
                [_vModelText, _ctx.profile.birthDate],
                [_directive_date]
              ])
            ]),
            _createVNode("div", _hoisted_11, [
              _createVNode("label", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "app_raccontaqualcosadite",
                  text: "Racconta qualcosa di te",
                  class: "fs_12 grey"
                })
              ]),
              _createVNode(_component_uose_writer, {
                class: "genericInput squareInput ptInput uoseWriter",
                modelValue: _ctx.profile.description,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.profile.description = $event)),
                ref: "chatInput",
                placeholderText: '',
                placeholderKey: ''
              }, null, 8, ["modelValue"])
            ]),
            _createVNode(_component_localized_text, {
              class: "fs_12 greyBlue d-block mt-2 mb-2",
              localizedKey: "app_sesso",
              text: "Sesso"
            }),
            _createVNode("div", _hoisted_12, [
              _createVNode("div", {
                class: ["filterTab", !_ctx.profile.gender ? 'active' : ''],
                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.profile.gender = ''))
              }, [
                _createVNode(_component_localized_text, {
                  class: "fs_12 d-block",
                  localizedKey: "app_nonspecificato",
                  text: "Non specificato"
                })
              ], 2),
              _createVNode("div", {
                class: ["filterTab", _ctx.profile.gender == _ctx.genders['male'] ? 'active' : ''],
                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.profile.gender = _ctx.genders['male']))
              }, [
                _createVNode(_component_localized_text, {
                  class: "fs_12 d-block",
                  localizedKey: "app_uomo",
                  text: "Uomo"
                })
              ], 2),
              _createVNode("div", {
                class: ["filterTab", _ctx.profile.gender == _ctx.genders['female'] ? 'active' : ''],
                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.profile.gender = _ctx.genders['female']))
              }, [
                _createVNode(_component_localized_text, {
                  class: "fs_12 d-block",
                  localizedKey: "app_donna",
                  text: "Donna"
                })
              ], 2)
            ])
          ]),
          (_ctx.error)
            ? (_openBlock(), _createBlock("span", _hoisted_13, _toDisplayString(_ctx.error), 1))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_14, [
            _createVNode("button", {
              class: "genericButton bgGreyBlue w-100",
              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.save()))
            }, [
              _createVNode(_component_localized_text, {
                class: "fs_14 white",
                localizedKey: "app_modifica",
                text: "Modifica"
              })
            ])
          ])
        ], 64))
  ]))
}